import {
  blue100,
  blueVioletDesat35,
  brownYellow25,
  brownYellow180,
  fluorescentBlueViolet69,
  fluorescentCyan185,
  fluorescentPink119,
  greenBlue100,
  greenBlueDesat155,
  orange100,
  orange135,
  pink115,
  violet155,
  violetPinkDesat100,
  yellowGreen100,
  yellowGreen135,
} from '@spotify-internal/encore-foundation';

export type ChartColorType =
  | 'pink'
  | 'flourescent'
  | 'yellowGreen'
  | 'brownYellow'
  | 'violet'
  | 'greenBlue'
  | 'blue'
  | 'orange'
  | 'greenBlueDesat';

const chartColors: {
  light: Record<ChartColorType, string>;
  dark: Record<ChartColorType, string>;
} = {
  light: {
    pink: fluorescentPink119,
    flourescent: fluorescentBlueViolet69,
    yellowGreen: yellowGreen100,
    brownYellow: brownYellow25,
    violet: violetPinkDesat100,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange100,
    greenBlueDesat: blueVioletDesat35,
  },
  dark: {
    pink: pink115,
    flourescent: fluorescentCyan185,
    yellowGreen: yellowGreen135,
    brownYellow: brownYellow180,
    violet: violet155,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange135,
    greenBlueDesat: greenBlueDesat155,
  },
};

export const getChartColors = (mode: 'light' | 'dark') => {
  return mode === 'light' ? chartColors.light : chartColors.dark;
};

export const defaultChartColors: ChartColorType[] = [
  'pink',
  'flourescent',
  'yellowGreen',
  'violet',
  'blue',
  'greenBlue',
  'orange',
  'greenBlueDesat',
  'brownYellow',
];
